import { render, staticRenderFns } from "./DeliveryBlockQualityProgram.vue?vue&type=template&id=05bd2456&"
import script from "./DeliveryBlockQualityProgram.vue?vue&type=script&lang=js&"
export * from "./DeliveryBlockQualityProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports